"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _PostAuthorMeta = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/PostAuthorMeta"));

var _TopLikedBy = _interopRequireDefault(require("../../TopLikedBy"));

var _likeStateUtils = require("../../likeStateUtils");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _PinnedReplyLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/pinned-reply/PinnedReplyLabel"));

var _permissions = require("@insided/deprecated-preact-components/utils/permissions");

var _PageUnloadContext = require("@insided/shared/services/PageUnloadContext");

var _Badges = _interopRequireDefault(require("@insided/deprecated-preact-components/User/Badges"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _TopicActions = _interopRequireDefault(require("../Shared/TopicActions"));

var _PostEditorV = _interopRequireDefault(require("@insided/shared/uikit/PostEditor/PostEditorV2"));

var _Attachments = _interopRequireDefault(require("../Shared/Attachments"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicReply = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicReply, _Component);

  var _super = _createSuper(TopicReply);

  function TopicReply(props) {
    var _this$props$reply$lik, _this$props$reply$top;

    var _this;

    (0, _classCallCheck2.default)(this, TopicReply);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showEditor: false,
      hasCurrentUserLiked: _this.props.currentUser.id !== null && _this.props.reply.likedBy.includes(_this.props.currentUser.id.toString()),
      likedBy: (_this$props$reply$lik = _this.props.reply.likedBy) !== null && _this$props$reply$lik !== void 0 ? _this$props$reply$lik : [],
      topLikedBy: (_this$props$reply$top = _this.props.reply.topLikedBy) !== null && _this$props$reply$top !== void 0 ? _this$props$reply$top : [],
      updatedReplyContent: _this.props.translatedReplyContent
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleLikeStatus", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var currentUser, hasCurrentUserLiked, normalizedCurrentUser;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentUser = _this.props.currentUser;
              hasCurrentUserLiked = _this.state.hasCurrentUserLiked;
              normalizedCurrentUser = _objectSpread(_objectSpread({}, currentUser), {}, {
                id: Number(currentUser.id)
              });

              _this.setState(function (prevState) {
                return (0, _likeStateUtils.updateLikedByState)(prevState.likedBy, prevState.topLikedBy, normalizedCurrentUser, !hasCurrentUserLiked);
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    _this.toggleLikeStatus = _this.toggleLikeStatus.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCancel = _this.onCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.shouldScrollToReply = _this.shouldScrollToReply.bind((0, _assertThisInitialized2.default)(_this));
    _this.programmaticallyScrollToReply = _this.programmaticallyScrollToReply.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicReply, [{
    key: "shouldScrollToReply",
    value: function shouldScrollToReply() {
      var reply = this.props.reply;
      var publicReplyId = reply.publicReplyId;
      var replyElementId = "post".concat(publicReplyId);
      var urlHash = window.location.hash;
      var shouldScrollToReply = urlHash === "#".concat(replyElementId);
      return shouldScrollToReply;
    }
  }, {
    key: "programmaticallyScrollToReply",
    value: function programmaticallyScrollToReply() {
      var reply = this.props.reply;
      var publicReplyId = reply.publicReplyId;
      var replyElementId = "post".concat(publicReplyId);
      var replyElement = document.getElementById(replyElementId);

      if (replyElement) {
        replyElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var isUserUsingFirefox, shouldScrollToReply;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isUserUsingFirefox = navigator.userAgent.includes('Mozilla');
                shouldScrollToReply = this.shouldScrollToReply();

                if (isUserUsingFirefox && shouldScrollToReply) {
                  this.programmaticallyScrollToReply();
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.translatedReplyContent !== this.props.translatedReplyContent && !this.state.showEditor) {
        this.setState({
          updatedReplyContent: this.props.translatedReplyContent
        });
      }
    }
  }, {
    key: "onChange",
    value: function onChange(content) {
      this.setState({
        updatedReplyContent: content
      });
    }
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.setState({
        showEditor: false,
        updatedReplyContent: this.props.translatedReplyContent || this.props.reply.content
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _authorInfo$name,
          _authorInfo$avatar,
          _authorInfo$url,
          _authorInfo$signature,
          _authorInfo$name2,
          _authorInfo$userTitle,
          _authorInfo$repliesMa,
          _this2 = this,
          _authorInfo$name3;

      var _this$props = this.props,
          parentTopicId = _this$props.parentTopicId,
          reply = _this$props.reply,
          displayAuthor = _this$props.displayAuthor,
          isLastItem = _this$props.isLastItem,
          contentType = _this$props.contentType,
          parentTopicTitle = _this$props.parentTopicTitle,
          disableFileAttachments = _this$props.disableFileAttachments,
          canMarkBestAnswer = _this$props.canMarkBestAnswer,
          isBestAnswer = _this$props.isBestAnswer,
          unlimitedEditPermission = _this$props.unlimitedEditPermission,
          languageList = _this$props.languageList,
          authors = _this$props.authors,
          showReputation = _this$props.showReputation,
          showBadges = _this$props.showBadges,
          attachmentCdn = _this$props.attachmentCdn,
          replyAttachments = _this$props.replyAttachments,
          parentTopicUrl = _this$props.parentTopicUrl,
          isTranslationInProgress = _this$props.isTranslationInProgress,
          showPostActions = _this$props.showPostActions,
          isAllRepliesTranslationInProgress = _this$props.isAllRepliesTranslationInProgress;
      var _this$state = this.state,
          updatedReplyContent = _this$state.updatedReplyContent,
          showEditor = _this$state.showEditor,
          hasCurrentUserLiked = _this$state.hasCurrentUserLiked,
          likedBy = _this$state.likedBy,
          topLikedBy = _this$state.topLikedBy;
      var data = reply.content,
          id = reply.id,
          highlighted = reply.highlighted,
          authorId = reply.authorId,
          creationDate = reply.repliedAt,
          publicReplyId = reply.publicReplyId,
          isPinnedReply = reply.isPinnedReply;
      var userId = authorId;
      var authorInfo = userId && authors ? authors[userId] : null;

      var _ref2 = authorInfo || {},
          badges = _ref2.badges,
          userLevel = _ref2.userLevel;

      var recentBadge = badges === null || badges === void 0 ? void 0 : badges[badges.length - 1];
      var user = {
        id: userId,
        name: (_authorInfo$name = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name !== void 0 ? _authorInfo$name : 'Anonymous',
        avatar: (_authorInfo$avatar = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.avatar) !== null && _authorInfo$avatar !== void 0 ? _authorInfo$avatar : '',
        url: (_authorInfo$url = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.url) !== null && _authorInfo$url !== void 0 ? _authorInfo$url : '',
        rank: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.rank,
        userLevel: authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userLevel,
        signature: (_authorInfo$signature = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.signature) !== null && _authorInfo$signature !== void 0 ? _authorInfo$signature : '',
        userName: (_authorInfo$name2 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name2 !== void 0 ? _authorInfo$name2 : '',
        userTitle: (_authorInfo$userTitle = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.userTitle) !== null && _authorInfo$userTitle !== void 0 ? _authorInfo$userTitle : ''
      }; // Initial content for translation reply context

      var initialContent = {
        title: parentTopicTitle,
        topicContent: null,
        bestAnswerText: null,
        pinnedReplyText: null,
        replies: [],
        individualReply: reply.content
      };
      return (0, _preact.h)(_HubAI.OnDemandTranslationProvider, {
        initialContent: initialContent,
        languageList: languageList,
        shouldTranslateOnlyOneReply: true
      }, (0, _preact.h)("div", {
        id: "post".concat(publicReplyId),
        className: (0, _classnames.default)('post', 'box__pad', 'qa-topic-post-box', {
          'post--pinned': isPinnedReply
        }, {
          'post--bestanswer': isBestAnswer
        }, {
          'post--modbreak': highlighted
        })
      }, (0, _preact.h)("div", {
        className: "post__user__info"
      }, (0, _preact.h)(_UserAvatar.default, {
        user: user,
        extraClass: "avatar avatar--responsive",
        showRank: true
      }), showReputation && userLevel > 0 && (0, _preact.h)("div", {
        className: "reputation"
      }, (0, _preact.h)("div", {
        className: "reputation__level--".concat(userLevel)
      })), showBadges && badges && badges.length > 0 && (0, _preact.h)(_Badges.default, {
        recentBadge: recentBadge,
        count: badges.length
      })), (0, _preact.h)(_PostAuthorMeta.default, {
        replyUser: user,
        replyCount: (_authorInfo$repliesMa = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.repliesMade) !== null && _authorInfo$repliesMa !== void 0 ? _authorInfo$repliesMa : 0,
        displayAuthor: displayAuthor,
        repliedAt: creationDate,
        isBestAnswer: isBestAnswer
      }), showEditor ? (0, _preact.h)(_PageUnloadContext.PageUnloadContext.Consumer, null, function (_ref3) {
        var lock = _ref3.lock,
            unlock = _ref3.unlock;
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('post__content', 'post__edit', 'qa-topic-post-edit')
        }, (0, _preact.h)(_PostEditorV.default, {
          type: contentType,
          data: data,
          disableFileAttachments: disableFileAttachments,
          topicId: parentTopicId,
          replyId: Number(id),
          isControl: false,
          onSuccess: function onSuccess(content) {
            unlock();

            _this2.setState({
              showEditor: false,
              updatedReplyContent: content
            });

            var postUrl = "".concat(parentTopicUrl, "?postid=").concat(publicReplyId, "#post").concat(publicReplyId);

            if (window.location.href.includes(postUrl)) {
              window.location.reload();
            } else {
              window.location.href = postUrl;
            }
          },
          onCancel: function onCancel() {
            unlock();

            _this2.onCancel();
          },
          redirect: false,
          isGuest: false,
          attachments: replyAttachments,
          onChange: function onChange(content) {
            lock(content, data);

            _this2.onChange(content);
          }
        }));
      }) : (0, _preact.h)(_HubAI.OnDemandTranslationContext.Consumer, null, function (_ref4) {
        var _ref5;

        var isTranslationInProgressForReply = _ref4.isTranslationInProgressForReply,
            isPostTranslatedForReply = _ref4.isPostTranslatedForReply,
            translatedReply = _ref4.translatedReply;

        if (isTranslationInProgressForReply) {
          _this2.programmaticallyScrollToReply();
        }

        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('topic-view-content-wrapper', {
            'translation-loading': (_ref5 = isTranslationInProgress !== null && isTranslationInProgress !== void 0 ? isTranslationInProgress : isTranslationInProgressForReply) !== null && _ref5 !== void 0 ? _ref5 : isAllRepliesTranslationInProgress
          })
        }, isPinnedReply && (0, _preact.h)("div", {
          className: "pinned-reply__label--comments"
        }, (0, _preact.h)(_PinnedReplyLabel.default, {
          phrase: (0, _preact.h)(_phrase.default, {
            p: "reply.pinned",
            m: "Forum"
          })
        })), (0, _preact.h)(_Content.default, {
          content: isPostTranslatedForReply ? translatedReply : updatedReplyContent,
          className: (0, _classnames.default)('post__content', 'qa-topic-post-content', 'post__content--new-editor')
        }), (0, _preact.h)(_HubAI.OnDemandTranslationButton, null));
      }), (0, _preact.h)("div", {
        className: "post__footer"
      }, replyAttachments && replyAttachments.length > 0 && (0, _preact.h)(_Attachments.default, {
        attachments: replyAttachments,
        attachmentCdn: attachmentCdn
      }), (user === null || user === void 0 ? void 0 : user.signature) && (0, _preact.h)("div", {
        className: "signature"
      }, user.signature), (likedBy === null || likedBy === void 0 ? void 0 : likedBy.length) > 0 && (0, _preact.h)(_TopLikedBy.default, {
        likedBy: likedBy,
        topLikedBy: topLikedBy,
        isCurrentUserLiked: hasCurrentUserLiked
      }), (0, _preact.h)(_TopicActions.default, {
        privateReplyId: Number(id),
        postId: Number(publicReplyId),
        contentType: contentType,
        onEditClick: function onEditClick() {
          return _this2.setState({
            showEditor: true
          });
        },
        isLiked: hasCurrentUserLiked,
        onLikeClick: this.toggleLikeStatus,
        showLike: true,
        showReportContent: true,
        showBestAnswer: canMarkBestAnswer,
        isBestAnswer: isBestAnswer,
        quoteText: reply.content,
        quoteUsername: (_authorInfo$name3 = authorInfo === null || authorInfo === void 0 ? void 0 : authorInfo.name) !== null && _authorInfo$name3 !== void 0 ? _authorInfo$name3 : '',
        showEdit: (0, _permissions.canLoginUserEditPost)(authorId, String(publicReplyId), creationDate, unlimitedEditPermission),
        topicTitle: parentTopicTitle,
        reply: reply,
        showPostActions: showPostActions,
        likedBy: likedBy
      })), (0, _preact.h)("hr", {
        className: "seperator m-b-0 ".concat(isLastItem ? 'is-transparant' : '')
      })));
    }
  }]);
  return TopicReply;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(TopicReply, ['isTranslationInProgress', 'languageList']);

exports.default = _default;
var cssAnchorName = 'topic-reply';
exports.cssAnchorName = cssAnchorName;